module.exports = __webpack_public_path__ + "static/img/pro6_tab1.8fe2c72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro6_tab1.jpg
// module id = ziHA
// module chunks = 171